// import React from 'react'
// import './Navbar.css'
// export const Navbar = () => {
//   return (
//     <>
//         {/* <div className='nav-container' style={{width: 1440, height: 65, background: 'rgba(255, 255, 255, 0.60)', borderTopLeftRadius: 20, borderTopRightRadius: 20, backdropFilter: 'blur(50px)'}} /> */}
//         <nav className="navbar">
//             <div className="navbar-logo">
//                 <img src="/images/louie_logo_hd_1.png" alt="Louie Voice Logo" />
//                 <span>Louie Voice</span>
//                 {/* <div style={{textAlign: 'center', color: '#080E57', fontSize: 24, fontFamily: 'Open Sans', fontWeight: '700', lineHeight: 37, wordWrap: 'break-word'}}>Louie Voice</div> */}
//             </div>
//             <ul className="navbar-links">
//                 <li><a href="#">Home</a></li>
//                 <li><a href="#">About Us</a></li>
//                 <li><a href="#">Use Cases</a></li>
//                 <li><a href="#">Languages</a></li>
//                 <li><a href="#">Join Louie Team</a></li>
//                 {/* <li className="contact-btn"> <a href='#'>Contact Us</a> </li>  */}
//                 <li className="contact-btn">Contact Us</li>
//             </ul>
//         </nav>
//     </>
//   )
// }



import React, { useCallback, useEffect, useRef, useState } from 'react';
import './NavbarDev.css'
import { Link, useNavigate } from 'react-router-dom';
import AudioRecorderModal from './AudioRecorderModal';
import TextMessageModal from './TextMessageModal';
import { useRecorderModal } from '../contextApi/RecorderModalContext';
export const NavbarDev = () => {
  const [showContact, setShowContact] = useState(false);
  const contactRef = useRef(null);
  const buttonRef = useRef(null); // Ref for the button
  const hamburgerRef = useRef(null); // Ref for the button
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRefMobile = useRef(null);
  const { openAudioModal, openTextModal, showRecorderModal, closeAudioModal, showTextModal, closeTextModal } = useRecorderModal();

  // const handleScroll = (event,id) => {
  //   event.preventDefault();
  //   const section = document.getElementById(id);
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const navigate = useNavigate();

  const handleMicIconClick = () => {
    console.log('mic_clicked')
    setShowContact(false)
    openAudioModal()
  }
  const handleChatIconClick = () => {
    setShowContact(false)
    openTextModal()
  }
  const onClose1 = (e) => {
    // if (e.target.classList.contains('modal-overlay')) {
    //   setShowTextModel(false);
    // }
    if (e.target.className.includes('modal-overlay') || e.target.className.includes('cancel')) {
      closeTextModal()
    }
  }

  const handleScroll = (event, id) => {
    event.preventDefault();
    setMenuOpen(false)
    // Navigate to home first if not already on home
    if (id == "join-louie-team") {
      navigate("/join-louie-team");
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0); // slight delay to allow routing to happen
    } else if (window.location.pathname !== "/") {
      navigate("/", { replace: true });

      // Delay scrolling to ensure navigation is completed
      setTimeout(() => {
        scrollToSection(id);
      }, 100);
    } else {
      scrollToSection(id);
    }
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const scrollToSection = (id) => {
  //   const section = document.getElementById(id);
  //   if (section) {
  //     const yOffset = -70; // Adjust this value as needed for mobile fine-tuning
  //     const y = section.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // };

  const handleClickOutside = useCallback((event) => {
    // console.log('inside hadle click outside')
    // console.log(!contactRef.current?.contains(event.target))
    // console.log(!buttonRef.current?.contains(event.target))
    setTimeout(() => {
      if (
        contactRef.current &&
        !contactRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowContact(false);
      }

    }, 0); // Allows state to update first

    // console.log(!menuRef.current?.contains(event.target))
    // console.log(!hamburgerRef.current?.contains(event.target))

    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target)
    ) {
      // console.log('menu ref')
      setMenuOpen(false);
    }
    // setShowContact(false)
  }, []);
  // console.log(showContact)
  // console.log('menuopen',menuOpen)
  useEffect(() => {
    if (showContact) {
      // console.log('event added due to show contact')
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    // else {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showContact, handleClickOutside, menuOpen]);

  // Basic mobile detection
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

  const email = 'hello@louievoice.com';

  const mobileLink = `mailto:${email}`;
  const desktopLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

  return (
    <>
      <nav className="navbar">
        {/* <div className="navbar-logo" onClick={(event)=>handleScroll(event,'home')}>
                    <img src="/images/louie_logo_hd_1.png" alt="Louie Voice Logo" />
                    <span>Louie Voice</span>
            </div> */}
        <div className="navbar-logo" onClick={(event) => handleScroll(event, 'home')}>
          <img src="/images/Louie_Clayfin_Logo_transparent.png" alt="Louie Voice Logo" />
        </div>
        {/* Hamburger Icon */}
        {/* <button className="menu-toggle" ref={hamburgerRef} onClick={() => {console.log('menu clicked');setMenuOpen(!menuOpen)}}>
                  ☰
                </button> */}
        <div className="navbar-items">
          {/* <div className="navbar-logo-mobile" onClick={(event) => handleScroll(event, 'home')}>
            <img src="/images/louie_logo_hd_1.png" alt="Louie Voice Logo" />
            <span>Louie Voice</span>
          </div> */}
          <div className="navbar-logo-mobile" onClick={(event) => handleScroll(event, 'home')}>
            <img src="/images/Louie_Clayfin_Logo_transparent.png" alt="Louie Voice Logo" />
            {/* <span>Louie Voice</span> */}
          </div>
          <button className="menu-toggle" ref={hamburgerRef} onClick={() => { setMenuOpen(!menuOpen) }}>
            ☰
          </button>
        </div>
        {/* <ul className="navbar-links"> */}
        <ul className={`navbar-links ${menuOpen ? "active" : ""}`} ref={menuRef}>
          <li><Link to="/" onClick={(event) => handleScroll(event, 'home')}>Home</Link></li>
          {/* <li><a href="/" onClick={(event)=>handleScroll(event,'home')}>Home</a></li> */}
          <li><Link href="/" onClick={(event) => handleScroll(event, 'about-us')}>About Us</Link></li>
          <li><Link href="/" onClick={(event) => handleScroll(event, 'inclusion')}>Use Cases</Link></li>
          <li><Link href="" onClick={(event) => handleScroll(event, 'language-section')} >Languages</Link></li>
          <li><Link to="/join-louie-team" onClick={(event) => handleScroll(event, 'join-louie-team')} >Join Louie Team</Link></li>
          {/* <li><a href="#">Join Louie Team</a></li> */}
          <button className="contact-btn" onClick={() => {
            setShowContact(!showContact)
            // setShowRecorderModel(false)
            // setShowTextModel(false)
            closeAudioModal()
            closeTextModal()
          }} ref={buttonRef} >Contact Us</button>
          {/* <li><Link className="contact-btn-li" onClick={() => setShowContact(!showContact)} ref={buttonRefMobile} >Contact Us</Link> </li> */}
        </ul>
      </nav>
      {showContact && (
        <>
          <div className="contact-dropdown" ref={contactRef}>
            <div className="nav-contact-icons">
              <a className='mobile-contact-us' onClick={() => {
                setShowContact(false)
              }} >Contact Us</a>
              {/* <hr className='mobile-contact-us'/> */}
              <hr className='mobile-hr' />
              <a href="https://www.linkedin.com/in/pramit-bhargava-1860668/" target="_blank" rel="noopener noreferrer" onClick={() => setShowContact(false)} >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path d="M3.80603 17H0.280804V5.65022H3.80603V17ZM2.04152 4.10201C0.914509 4.10201 0 3.16853 0 2.04152C0 1.50007 0.215088 0.980806 0.597947 0.597947C0.980806 0.215088 1.50007 0 2.04152 0C2.58296 0 3.10223 0.215088 3.48509 0.597947C3.86795 0.980806 4.08304 1.50007 4.08304 2.04152C4.08304 3.16853 3.16853 4.10201 2.04152 4.10201ZM16.9962 17H13.4786V11.475C13.4786 10.1583 13.452 8.46964 11.6458 8.46964C9.81295 8.46964 9.53214 9.90022 9.53214 11.3801V17H6.01071V5.65022H9.39174V7.19844H9.44107C9.91161 6.3067 11.0614 5.36562 12.7766 5.36562C16.3435 5.36562 17 7.71451 17 10.7654V17H16.9962Z" fill="#080E57" />
                </svg> LinkedIn
              </a>
              <hr />
              <a
                onClick={() => setShowContact(false)}
                href={isMobile ? mobileLink : desktopLink}
                target={isMobile ? '_self' : '_blank'}
                rel="noopener noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                  <path d="M1.875 0C0.839844 0 0 0.839844 0 1.875C0 2.46484 0.277344 3.01953 0.75 3.375L9.25 9.75C9.69531 10.082 10.3047 10.082 10.75 9.75L19.25 3.375C19.7227 3.01953 20 2.46484 20 1.875C20 0.839844 19.1602 0 18.125 0H1.875ZM0 4.375V12.5C0 13.8789 1.12109 15 2.5 15H17.5C18.8789 15 20 13.8789 20 12.5V4.375L11.5 10.75C10.6094 11.418 9.39062 11.418 8.5 10.75L0 4.375Z" fill="#080E57" />
                </svg> Email
              </a>
              <hr />
              <a onClick={handleMicIconClick} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="23" viewBox="0 0 16 23" fill="none">
                  <path d="M8 0C5.59091 0 3.63636 1.93164 3.63636 4.3125V11.5C3.63636 13.8809 5.59091 15.8125 8 15.8125C10.4091 15.8125 12.3636 13.8809 12.3636 11.5V4.3125C12.3636 1.93164 10.4091 0 8 0ZM2.18182 9.70312C2.18182 9.10566 1.69545 8.625 1.09091 8.625C0.486364 8.625 0 9.10566 0 9.70312V11.5C0 15.5025 3.00909 18.8088 6.90909 19.3344V20.8438H4.72727C4.12273 20.8438 3.63636 21.3244 3.63636 21.9219C3.63636 22.5193 4.12273 23 4.72727 23H8H11.2727C11.8773 23 12.3636 22.5193 12.3636 21.9219C12.3636 21.3244 11.8773 20.8438 11.2727 20.8438H9.09091V19.3344C12.9909 18.8088 16 15.5025 16 11.5V9.70312C16 9.10566 15.5136 8.625 14.9091 8.625C14.3045 8.625 13.8182 9.10566 13.8182 9.70312V11.5C13.8182 14.676 11.2136 17.25 8 17.25C4.78636 17.25 2.18182 14.676 2.18182 11.5V9.70312Z" fill="#080E57" />
                </svg>
                Send Audio Note</a>
              <hr />
              <a onClick={handleChatIconClick} >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <path d="M20 8.35714C20 12.9737 15.5237 16.7143 10.0006 16.7143C8.55144 16.7143 7.17652 16.4571 5.93441 15.9951C5.46959 16.3446 4.71182 16.8228 3.81344 17.2246C2.87599 17.6424 1.74715 18 0.626122 18C0.372231 18 0.145681 17.8433 0.0480306 17.6022C-0.04962 17.3612 0.00506435 17.0879 0.180835 16.9031L0.192553 16.8911C0.204272 16.879 0.219896 16.8629 0.243332 16.8348C0.286298 16.7866 0.3527 16.7103 0.434727 16.6058C0.594874 16.4049 0.809705 16.1076 1.02844 15.7379C1.41904 15.071 1.79012 14.1951 1.86433 13.2107C0.692525 11.8446 0.00115834 10.1692 0.00115834 8.35714C0.00115834 3.74062 4.47746 0 10.0006 0C15.5237 0 20 3.74062 20 8.35714Z" fill="#080E57" />
                </svg>
                Send Text Message</a>
            </div>
          </div>
        </>
      )}
      {showRecorderModal ? (
        <AudioRecorderModal onClose={closeAudioModal} />
      ) :
        ""
      }
      {showTextModal ? (
        <TextMessageModal onClose={onClose1} />
      ) :
        ""
      }
    </>
  );
};

